import { Component, OnInit } from "@angular/core";
import { CompanyService } from "./../services/company.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  styleUrls: ["./company.component.css"],
})
export class CompanyComponent implements OnInit {
  companyForm: FormGroup;
  companyItemsForm: FormGroup;
  allCompany: any;
  selectedCompany: any;
  companyItems: any;
  seletedItem: any;
  p: number = 1;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }
  createForm() {
    this.companyForm = this.fb.group({
      name: ["", Validators.required],
      gst: ["", Validators.required],

      address: ["", Validators.required],
      city: ["", Validators.required],
      state: ["Tamilnadu", Validators.required],
      stateCode: ["33", Validators.required],
      serviceAccountCode: ["998898", Validators.required],

      ourDc: ["true", Validators.required],
      yourDc: ["true", Validators.required],
      billDifferentType: ["true", Validators.required],
      displayTotNos: ["true", Validators.required],
    });

    this.companyItemsForm = this.fb.group({
      itemName: ["", Validators.required],
      itemRate: ["", Validators.required],
      itemPieces: ["false", Validators.required],
    });
  }

  ngOnInit() {
    this.getAllCompanies();
  }

  addCompany() {
    if (this.companyForm.valid) {
      console.log(this.companyForm.value);

      let obj = {
        isNew: true,
        code: "abc",
        name: this.companyForm.value.name,
        diffBill: true,
        address: this.companyForm.value.address,
        city: this.companyForm.value.city,
        state: this.companyForm.value.state,
        stateCode: this.companyForm.value.stateCode,
        gst: this.companyForm.value.gst,
        serviceAccountCode: this.companyForm.value.serviceAccountCode,
        ourDc: this.companyForm.value.ourDc,
        yourDc: this.companyForm.value.yourDc,
        billDifferentType: this.companyForm.value.billDifferentType,
        displayTotNos: this.companyForm.value.displayTotNos,
      };

      this.companyService.storeCompanyDetails(obj).subscribe(
        (res: any) => {
          console.log(res);
          // this.allCompany = res.data;
          this.getAllCompanies();
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      alert("Form is invalid");
    }
  }

  fillUpdateForm() {
    this.companyForm = this.fb.group({
      name: [this.selectedCompany.name, Validators.required],
      gst: [this.selectedCompany.gst, Validators.required],

      address: [this.selectedCompany.address, Validators.required],
      city: [this.selectedCompany.city, Validators.required],
      state: [this.selectedCompany.state, Validators.required],
      stateCode: [this.selectedCompany.stateCode, Validators.required],
      serviceAccountCode: [
        this.selectedCompany.serviceAccountCode,
        Validators.required,
      ],

      ourDc: [this.selectedCompany.ourDc.toString(), Validators.required],
      yourDc: [this.selectedCompany.yourDc.toString(), Validators.required],
      billDifferentType: [
        this.selectedCompany.billDifferentType.toString(),
        Validators.required,
      ],
      displayTotNos: [
        this.selectedCompany.displayTotNos.toString(),
        Validators.required,
      ],
    });
  }

  getOneCompany(id) {
    console.log(id);

    this.allCompany.forEach((element) => {
      if (element._id == id) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    });

    this.companyService.getCompany(id).subscribe(
      (res: any) => {
        console.log(res);
        this.selectedCompany = res.data;
        this.fillUpdateForm();
        this.getCompanyItems(this.selectedCompany._id);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  updateCompany() {
    console.log(this.selectedCompany);

    if (this.companyForm.valid) {
      console.log(this.companyForm.value);

      let obj = {
        isNew: false,
        id: this.selectedCompany._id,
        code: "abc",
        name: this.companyForm.value.name,
        diffBill: true,
        address: this.companyForm.value.address,
        city: this.companyForm.value.city,
        state: this.companyForm.value.state,
        stateCode: this.companyForm.value.stateCode,
        gst: this.companyForm.value.gst,
        serviceAccountCode: this.companyForm.value.serviceAccountCode,
        ourDc: this.companyForm.value.ourDc,
        yourDc: this.companyForm.value.yourDc,
        billDifferentType: this.companyForm.value.billDifferentType,
        displayTotNos: this.companyForm.value.displayTotNos,
      };

      this.companyService.storeCompanyDetails(obj).subscribe(
        (res: any) => {
          console.log(res);
          this.companyForm.reset();
          this.getAllCompanies();
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      alert("Form is invalid");
    }
  }

  deSelectCompany() {
    this.selectedCompany = null;
    this.companyForm.reset();
    this.allCompany.forEach((element) => {
      element.selected = false;
    });
  }

  deSelectItem() {
    this.seletedItem = null;
    this.companyItemsForm.reset();
  }

  deleteCompany() {
    if (confirm("Are you sure to delete company?") == true) {
      this.companyService.removeCompany(this.selectedCompany._id).subscribe(
        (res: any) => {
          console.log(res);
          this.getAllCompanies();
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
    }
  }

  addCompanyItem() {
    if (this.companyItemsForm.valid) {
      console.log(this.companyItemsForm.value);

      let obj = {
        isNew: true,
        companyId: this.selectedCompany._id,
        name: this.companyItemsForm.value.itemName,
        rate: this.companyItemsForm.value.itemRate,
        pieces: this.companyItemsForm.value.itemPieces,
      };

      this.companyService.storeItemDetails(obj).subscribe(
        (res: any) => {
          console.log(res);
          this.companyItemsForm.reset();
          this.getCompanyItems(this.selectedCompany._id);
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      alert("Items Form is invalid");
    }
  }

  editCompanyItem(item) {
    this.seletedItem = item;

    this.companyItemsForm = this.fb.group({
      itemName: [item.name, Validators.required],
      itemRate: [item.rate, Validators.required],
      itemPieces: [item.pieces.toString(), Validators.required],
    });
  }

  updateCompanyItem() {
    if (this.companyItemsForm.valid) {
      console.log(this.companyItemsForm.value);

      let obj = {
        isNew: false,
        id: this.seletedItem._id,
        companyId: this.selectedCompany._id,
        name: this.companyItemsForm.value.itemName,
        rate: this.companyItemsForm.value.itemRate,
        pieces: this.companyItemsForm.value.itemPieces,
      };

      this.companyService.storeItemDetails(obj).subscribe(
        (res: any) => {
          console.log(res);
          this.companyItemsForm.reset();
          this.getCompanyItems(this.selectedCompany._id);
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      alert("Items Form is invalid");
    }
  }

  deleteItem(item) {
    if (confirm("Are you sure to delete Item?") == true) {
      this.companyService.removeCompanyItem(item._id).subscribe(
        (res: any) => {
          console.log(res);
          this.getCompanyItems(this.selectedCompany._id);
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  backToHome() {
    this.router.navigate(["/home"]);
  }

  getAllCompanies() {
    this.selectedCompany = null;
    this.companyService.getCompany("all").subscribe(
      (res: any) => {
        console.log(res);
        this.allCompany = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getCompanyItems(companyId) {
    this.seletedItem = null;
    this.companyService.getCompanyItems(companyId).subscribe(
      (res: any) => {
        console.log(res);
        this.companyItems = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/company/company.component.ts